import useResize from '@anm/hooks/useResize';
import { useEffect, useRef, useState } from 'react';
type UseWithCalculationProps = {
  width: number;
  padding?: number;
};

export const useWithCalculation = ({
  width,
  padding = 0
}: UseWithCalculationProps) => {
  const sizeMeterRef = useRef<HTMLDivElement>(null);
  const [newWidth, setNewWidth] = useState(0);

  const calcNewWidth = () => {
    if (!sizeMeterRef.current) return;

    const { clientWidth } = sizeMeterRef.current!;
    const fit = Math.floor((clientWidth - padding) / width);
    setNewWidth(fit * width + padding);
  };

  useResize(calcNewWidth);

  useEffect(() => {
    calcNewWidth();
  }, [width]);

  return [newWidth, sizeMeterRef] as const;
};
